// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"JoinedTooEarlyStyles_mainContainer__2i72s","title":"JoinedTooEarlyStyles_title__jiUnT","explanation":"JoinedTooEarlyStyles_explanation__3QFVy"};